import { render, staticRenderFns } from "./publishRFCNumStatus.vue?vue&type=template&id=1db93e39&scoped=true&"
import script from "./publishRFCNumStatus.vue?vue&type=script&lang=js&"
export * from "./publishRFCNumStatus.vue?vue&type=script&lang=js&"
import style0 from "./publishRFCNumStatus.vue?vue&type=style&index=0&id=1db93e39&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db93e39",
  null
  
)

export default component.exports